function getUserTimezoneOffsetInHours() {
    const offsetInMinutes = new Date().getTimezoneOffset();
    return -offsetInMinutes / 60;
}

module.exports = {
    getUserTimezoneOffsetInHours,
};
